import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPageLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 69,
	height: 38,
	viewBox: "0 0 69 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M36.7421 22.8516L68.7435 11.0699L34.3717 0L0 12.6823V25.127L34.3717 37.7615L68.7435 25.1031V22.5434L36.7421 34.3245V32.2645L68.7435 20.4807V17.9443L36.7421 29.7022V27.6394L68.7435 15.835V13.3219L36.7421 25.1031V22.8516Z",
		fill: "#131523"
	})
});
export default SvgPageLogo;
